<div
  *ngIf="files == null || files.length === 0"
  fxLayout="column"
  fxLayoutAlign="center center"
  fxFlexFill
>
  <span class="no-files-text hint-text pt-32">There are no attachments</span>
</div>
<div *ngIf="files?.length > 0">
  <div *ngFor="let file of files" class="file-list">
    <file-list-item
      class="p-16 clickable bottom-border row list-item"
      [item]="file"
      [readOnly]="readOnly"
      [userCanDeleteAttachments]="userCanDeleteAttachments"
      [parent]="_parent"
      [selected]="selectedItems.includes(file?.id)"
      [ngClass]="{ selected: selectedItems.includes(file?.id) }"
      [ngStyle]="{'cursor': file.attachmentType == 1 ? 'default' : 'pointer'}"
    >
    </file-list-item>
  </div>
</div>
